import type { CustomCellRendererProps } from "ag-grid-react";

import { FileIconComponent } from "@synthesis/shared-ui";

import { getFileExtension, type ReviewDocumentRow, type ReviewDocumentTableContext } from "./review-documents-tab.lib";

export const ReviewDocumentFileNameCell = ({ data, context }: CustomCellRendererProps<ReviewDocumentRow, unknown, ReviewDocumentTableContext>) => {
  if (!data) {
    return null;
  }

  return (
    <div className="flex min-w-0 items-center gap-2">
      <FileIconComponent className="size-6 shrink-0" ext={getFileExtension(data.fileName)} />
      <button
        type="button"
        className="paragraph-base text-system-info-50 min-w-0 truncate text-left hover:underline"
        onClick={() => context.onDownload(data)}
        title={data.fileName}
      >
        {data.fileName}
      </button>
    </div>
  );
};
